import React, {Suspense} from 'react'
import Loading from './Loading.js'

const RootRouteAuthenticated = React.lazy(() =>
  import('./RootRouteAuthenticated.js'),
)

const RootRouteAuthenticatedAsync = (props) => (
  <Suspense fallback={<Loading />}>
    <RootRouteAuthenticated {...props} />
  </Suspense>
)

export default RootRouteAuthenticatedAsync
